<template>
  <div class="standard-config-container">
    <div class="config-header">
      <h4>参数：{{currentStandardParam.paramName }}</h4>
      <p>设置该参数的标准值或标准值范围</p>
    </div>
    <el-form ref="standardFormRef" :model="standardForm" :rules="standardFormRules" label-width="100px">
      <el-form-item label="标准值类型" prop="standardType">
        <ic-select table="TT_PROC" field="STANDARD_TYPE" v-model="standardForm.standardType" style="width:100%"></ic-select>
      </el-form-item>
      <el-form-item v-if="standardForm.standardType === 'SINGLE'" label="标准值" prop="standard">
        <el-input-number v-model="standardForm.standard" placeholder="请输入标准值" style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="standardForm.standardType === 'RANGE'" label="最小值" prop="minValue">
        <el-input-number v-model="standardForm.minValue" placeholder="请输入最小值" style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="standardForm.standardType === 'RANGE'" label="最大值" prop="maxValue">
        <el-input-number v-model="standardForm.maxValue" placeholder="请输入最大值" style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="standardForm.standardType === 'OPERATOR'" label="操作符" prop="operator">
        <el-select v-model="standardForm.operator" placeholder="选择操作符" style="width: 100%">
          <el-option label="大于 (>)" value=">" />
          <el-option label="大于等于 (>=)" value=">=" />
          <el-option label="小于 (<)" value="<" />
          <el-option label="小于等于 (<=)" value="<=" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="standardForm.standardType === 'OPERATOR'" label="比较值" prop="operatorValue">
        <el-input-number v-model="standardForm.operatorValue" placeholder="请输入比较值" style="width: 100%" />
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center" align="middle">
      <el-button size="mini" @click="onSave" type="primary">保存设置</el-button>
      <el-button size="mini" @click="onCancel" type="primary">取消</el-button>
    </el-row>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
export default {
  props: ['standardFormConfig', 'currentStandardParamConfig'],
  components: { IcSelect },
  data() {
    return {
      currentStandardParam: {
        paramName: "",
        dataType: "",
      },
      standardForm: {
        standardType: "NA",
        standard: "",
        minValue: null,
        maxValue: null,
        operator: "",
        operatorValue: null,
      },
      standardFormRules: {
        standardType: [{ required: true, message: "请选择标准值类型", trigger: "change" }],
        standardValue: [{ required: true, message: "请输入标准值", trigger: "blur" }],
        minValue: [{ required: true, message: "请输入最小值", trigger: "blur" }],
        maxValue: [
          { required: true, message: "请输入最大值", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && this.standardForm.minValue && value <= this.standardForm.minValue) {
                callback(new Error("最大值必须大于最小值"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        operator: [{ required: true, message: "请选择操作符", trigger: "change" }],
        operatorValue: [{ required: true, message: "请输入比较值", trigger: "blur" }],
      }
    }
  },
  watch: {
    currentStandardParamConfig: {
      handler(newV) {
        console.log("🚀 ~ handler ~ newV:", newV)
        this.currentStandardParam = { ...newV }
      },
      immediate: true,
      deep: true,
    },
    standardFormConfig: {
      handler(newV) {
        console.log("🚀 ~ handler ~ newV:", newV)
        this.standardForm = { ...newV }
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    handleStandardTypeChange(val) {
      console.log("🚀 ~ handleStandardTypeChange ~ val:", val)
      // 切换标准值类型时重置相关字段
      this.standardForm.standard = null;
      this.standardForm.minValue = null;
      this.standardForm.maxValue = null;
      this.standardForm.operator = "";
      this.standardForm.operatorValue = null;
    },

    onSave() {
      this.$refs['standardFormRef'].validate((valid) => {
        if (valid) {
          var standard = ""
          switch (this.standardForm.standardType) {
            case 'SINGLE':
              standard = this.standardForm.standard
              break;
            case 'RANGE':
              standard = this.standardForm.minValue + '-' + this.standardForm.maxValue
              break;
            case 'OPERATOR':
              standard = this.standardForm.operator + this.standardForm.operatorValue
              break;
            case 'NA':

              break;
          }
          this.$emit('handleSaveStandardConfig', {
            standardType: this.standardForm.standardType,
            standard: standard,
          })
        }
      })
    },
    onCancel() {
      this.$refs['standardFormRef'].resetFields()
      this.$emit('onCloseParamStandardDialog')
    }
  }
}
</script>